import React, { useEffect, useState } from "react";
import useHttp from "../../hooks/use-http";
import { useSelector} from "react-redux";
import { endPoints } from "../../config/end-points";
import { saveLocalData } from "../../helpers/storage-helper";
// import { cuteToast } from "../UI/cute";




const ScriptDiv = ( props ) => {

  
    const {sendRequest: rewriteText} = useHttp();
    const [ pageloader, setPageloader ] = useState(false);

    const editSlideData = useSelector((state) => state.campaign.editSlideData);

    const { setShowvideo_script, script_data } = props;
    const [script_data1, setScript_data1] = useState("");
    
    // const [ charCount , setCharCount ] = useState([0]);
    
    useEffect(() => {
        
            let data = script_data;
            // data = JSON.parse(data);
            setScript_data1(data);
            console.log(data);
        // eslint-disable-next-line
    },[props]);

    const hidediv = () => {
        setShowvideo_script(false);
    }

  useEffect(() => {
    if(editSlideData){

        const dataArray = Object.entries(editSlideData);
        let quotes = '';

        dataArray.map(([key, value]) => {
            
          if(key && key.includes("engageleads")){
            quotes += value+' ';
          }
          return null;
        });

        // setPromt(quotes);
        console.log(quotes);

    }
  }, [editSlideData ]);
  
  

  const rewriteData = async ( scene_name, index) => {

    var promt = '';
    script_data1.filter((data) => {
        if(data.scene_name === scene_name){
            promt = data.scene_content;
        }
        return true;
    });

    let character_lenght = document.querySelector(`.scane${index}`).value;

    var int_character_lenght = parseInt(character_lenght);

    if(character_lenght === '' || character_lenght === undefined || character_lenght === null || character_lenght === 0 || int_character_lenght > 300 ) {
      character_lenght = promt.length ;
    }
    
    // console.log(typeof int_character_lenght);
    // console.log(character_lenght);
    
    setPageloader(true);

    let promt1 = "Please Rewrite the following content:  '" + promt + "' and the length should not be exceed " + character_lenght + " characters.";
    rewriteText(
      {
        url: endPoints.genQuote,
        method: "POST",
        body: {
          promt: promt1 ,
          max_tokens: 200
        }
      },
      async (response) => {
        
        setPageloader(false);

        // console.log(response, scene_name);
        // response = response.trim();

        if( response.status === 200){
        
          var temp = script_data1.map((data) => {
              if (data.scene_name === scene_name) {
                  data.scene_content = response.data.trim();
              }
              return data;
          });

          setScript_data1(temp);
          // temp = JSON.stringify(temp);
          saveLocalData("script_data", temp);
        }else{
          console.log(response.message);
          // cuteToast({
          //           type: "error",
          //           message: response.message,
          //           timer: 5000,
          //           title: '',
          //         });
        }

      }
    );
  };





  const hendleupdate = (e, scene_name) => {

    console.log(scene_name);
    var temp = script_data1.filter((data) => {

        var udata = e.target.value;
        if(data.scene_name === scene_name){
            data.scene_content = udata;
        }
      return true;
    });

    setScript_data1(temp);
    saveLocalData("script_data", temp);
}






  return (
    <>
      
      <div className="row position-relative ">
        {pageloader && (
            <div className="position-absolute mini_loader">
              <div className="loader2">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          )}

          <div className="col-md-12 px-3 text-align-left inner_script_section">
            <div className="mb-3">
              <button type="button" className="position-absolute ai_div-cross d-none" onClick={hidediv} >X</button>
              <label className="form-label"><b>Script</b></label>

              { script_data1 && script_data1.map((data, index) => {

                  // i want array of characters count for each scene
                  // var charCount = data.scene_content.length;
                  // setCharCount(charCount);
                  // console.log(charCount);
                  
                    return (
                        <div key={index} className="form-group v_scenes">
                            <label className="form-label scene_name">Scene {(index+1)}: {data.scene_name}</label>
                            {/* <div >{data.scene_content}</div> */}
                            <textarea className="form-control mb-2" value={data.scene_content} onChange={ (e) => { hendleupdate(e,data.scene_name) } } ></textarea>
                            <div className="d-flex justify-content-end  mb-1">
                              <span className=""> 
                              Character Length: 
                              <input type="number"  
                              className= {`character_lenght scane${index} `}
                              onChange={
                                (e) => {
                                  console.log(e.target.value);
                                  if(data.scene_content.length < e.target.value){
                                    // e.target.classList.add('is-invalid-red');
                                  }else{
                                    e.target.classList.remove('is-invalid-red');
                                  }
                                }
                              } />
                              </span>

                                <span className="rewrite" onClick = { () => { rewriteData( data.scene_name, index) } }  >Rewrite</span>
                            </div>
                        </div>
                    )
                })
                
                
                }

              
            </div>
          </div>

          


      </div>

      
    </>
  );
};

export default ScriptDiv;
